import { translations } from '../../_translations';
import { CodeType } from '../_models';

export function labelForCodeType(type: CodeType): string {
  return translations.getLabel(`CODES.TYPE.OPTIONS.${type}`);
}
